import { render, staticRenderFns } from "./activity-new_user_sign.vue?vue&type=template&id=4d7e0226&scoped=true&"
import script from "./activity-new_user_sign.vue?vue&type=script&lang=js&"
export * from "./activity-new_user_sign.vue?vue&type=script&lang=js&"
import style0 from "./activity-new_user_sign.vue?vue&type=style&index=0&id=4d7e0226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7e0226",
  null
  
)

export default component.exports